const basePath = '/account-management';

export const crmRoutes = {
  root: basePath,
  accountList: `${basePath}/accounts`,
  accountDetails: `${basePath}/accounts/:accountId`,
} as const;
